import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import {
  CalendarTodayOutlined,
  GridViewOutlined,
  CoPresentOutlined,
  AutoStoriesOutlined,
  InsertDriveFileOutlined,
  LibraryBooksOutlined,
  PlaylistRemoveOutlined,
    CodeRounded,
} from "@mui/icons-material";
import { Menu } from "antd";

const Side = ({ collapsed }) => {
  const navigate = useNavigate();
  const [selectedKey, setSelectedKey] = useState("/");

  const menuItems = [
    {
      key: "/",
      icon: <GridViewOutlined />,
      label: !collapsed ? 'Home' : null,
    },
    {
      key: "/portfolios",
      icon: <LibraryBooksOutlined />,
      label: !collapsed ? 'Portfolios' : null,
    },
    {
      key: "/calendar",
      icon: <CalendarTodayOutlined />,
      label: !collapsed ? 'Calendar' : null,
    },
    {
      key: "/resources",
      icon: <CoPresentOutlined />,
      label: !collapsed ? 'Resources' : null,
    },
    {
      key: "/widgets/blacklist",
      icon: <PlaylistRemoveOutlined />,
      label: !collapsed ? 'Blacklist' : null,
    },
    {
      key: "/pages",
      icon: <AutoStoriesOutlined />,
      label: !collapsed ? 'Pages' : null,
    },
    {
      key: "/files",
      icon: <InsertDriveFileOutlined />,
      label: !collapsed ? 'Files' : null,
    },
    {
      key: '/beta/launcher',
      icon: <CodeRounded />,
      label: 'Beta',

    }
  ];

  const handleMenuClick = (e) => {
    navigate(e.key);
    setSelectedKey(e.key);
  };

  return (
    <Menu
      mode="vertical"
      selectedKeys={[selectedKey]}
      onClick={handleMenuClick}
      theme="dark"
      items={menuItems}
      style={{
        background: "var(--primary)",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    />
  );
};

export default Side;
